<template>
    <div>
        <table
            v-if="ipsToShow.length > 0"
            class="table table-hover"
        >
            <thead>
                <tr>
                    <th class="text-left">ID</th>
                    <th class="text-left">IP</th>
                    <th class="text-left">Type</th>
                    <th class="text-left">Group</th>
                </tr>
            </thead>
            <tbody>
                <ip-component
                    v-for="(ip, index) in ipsToShow"
                    :key="ip.id"
                    :index="index"
                    :ip="ip"
                    :ipGroups="ipGroups"
                >
                </ip-component>
            </tbody>
        </table>
        <p v-else class="empty-data">
            The group has no non-used IPs
        </p>
    </div>
</template>

<script>
import IpComponent from "./IpComponent";

export default {
    props: {
        ips: Array,
        ipGroups: Array,
        type: {
            type: Number,
            default: undefined
        }
    },
    computed: {
        ipsToShow: function () {
            return typeof this.type === 'number'
                ? this.ips.filter((item) => item.type === this.type)
                : this.ips;
        }
    },
    components: {
        IpComponent
    }
}
</script>
<style scoped>
.empty-data {
    margin: 10px 0;
    text-align: center;
}
table {
    margin: 0;
}
</style>
